import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { MapPage } from '../pages/map/map';
import { FavoritesPage } from '../pages/favorites/favorites';
import { SearchPage } from '../pages/search/search';
import { TabsControllerPage } from '../pages/tabs-controller/tabs-controller';
import { LocationDetailsPage } from '../pages/location-details/location-details';
import { Product_detailsPage } from '../pages/product_details/product_details';
import { DemopagePage } from '../pages/demopage/demopage';
import { SplashPage } from '../pages/splash/splash';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

// PRO
import { Pro } from '@ionic/pro';
import { Injectable, Injector } from '@angular/core';
import { ProductsProvider } from '../providers/products/products';

Pro.init('9fbe16f3', {
  appVersion: '0.0.1'
})
// \PRO

@Injectable()
export class MyErrorHandler implements ErrorHandler {
  ionicErrorHandler: IonicErrorHandler;

  constructor(injector: Injector) {
    try {
      this.ionicErrorHandler = injector.get(IonicErrorHandler);
    } catch(e) {
      // Unable to get the IonicErrorHandler provider, ensure
      // IonicErrorHandler has been added to the providers list below
    }
  }

  handleError(err: any): void {
    Pro.monitoring.handleNewError(err);
    // Remove this if you want to disable Ionic's auto exception handling
    // in development mode.
    this.ionicErrorHandler && this.ionicErrorHandler.handleError(err);
  }
}

@NgModule({
  declarations: [
    MyApp,
    MapPage,
    FavoritesPage,
    SearchPage,
    TabsControllerPage,
    LocationDetailsPage,
    Product_detailsPage,
    DemopagePage,
    SplashPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    MapPage,
    FavoritesPage,
    SearchPage,
    TabsControllerPage,
    LocationDetailsPage,
    Product_detailsPage,
    DemopagePage,
    SplashPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    IonicErrorHandler,
    [{ provide: ErrorHandler, useClass: MyErrorHandler }],
    ProductsProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts